import {
  So5FixtureEvent,
  Sport,
} from '@sorare/core/src/__generated__/globalTypes';
import { useSportContext } from '@sorare/core/src/contexts/sport';
import { useLocalStorage } from '@sorare/core/src/hooks/useLocalStorage';

import { getValidEventType } from '#src/lib/so5.ts';

export const useLastVisitedEventType = () => {
  const { sport } = useSportContext();
  const [lastVisitedEventType, setLastVisitedEventType] = useLocalStorage(
    'lastVisitedEventType',
    So5FixtureEvent.DAILY.toLowerCase()
  );

  // So lastVisitedEventType is normalized and always in lowercase
  const formattedSetLastVisitedEventType = (
    eventType: So5FixtureEvent | string
  ) => {
    setLastVisitedEventType(eventType.toLowerCase());
  };

  if (
    lastVisitedEventType !==
    getValidEventType(lastVisitedEventType).toLowerCase()
  ) {
    formattedSetLastVisitedEventType(So5FixtureEvent.CLASSIC);
  }

  return {
    lastVisitedEventType:
      sport === Sport.FOOTBALL
        ? So5FixtureEvent.CLASSIC.toLowerCase()
        : lastVisitedEventType,
    setLastVisitedEventType: formattedSetLastVisitedEventType,
  };
};
